import React from 'react'
import img from "../assets/logo/card.jpeg"

const BottomFooter = () => {
    
    const currentYear = new Date().getFullYear();

    return (
        <>
        <div className="bottom-footer">
            <div className="container container-lg">
                <div className="bottom-footer__inner">
                    
                    <p className="bottom-footer__text">
                       Kalpanamart © {currentYear}/Developed by Sai Techno Solutions
                    </p>

                    <div className="payment-section">
                        <span className="payment-label">
                            We Are Accepting
                        </span>
                        
                        <div className="payment-box">
                            <img src={img} alt="Payment Methods" />
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <style>{`
        .bottom-footer {
            background-color: #083d74;
            border-top: 1px solid #062d55;
            padding: 20px 0;
        }

        .bottom-footer__inner {
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 16px;
            flex-wrap: wrap;
        }

        .bottom-footer__text {
            color: #ffffff;
            font-size: 14px;
            opacity: 0.9;
            margin: 0;
        }

        .payment-section {
            display: flex;
            align-items: center;
            gap: 12px;
            flex-wrap: wrap;
        }

        .payment-label {
            color: #d1d9e0;
            font-weight: 500;
            font-size: 14px;
        }

        .payment-box {
            background: #fff;
            padding: 6px 12px;
            border-radius: 6px;
            display: flex;
            align-items: center;
            box-shadow: 0 2px 8px rgba(0,0,0,0.2);
        }

        .payment-box img {
            max-height: 24px;
            width: auto;
        }

        /* ✅ Tablet (≤1024px) */
        @media (max-width: 1024px) {
            .bottom-footer__inner {
                flex-direction: column;
                text-align: center;
                gap: 12px;
            }

            .payment-section {
                justify-content: center;
            }
        }

        /* ✅ Mobile (≤768px) */
        @media (max-width: 768px) {
            .bottom-footer__text {
                font-size: 13px;
            }

            .payment-label {
                font-size: 13px;
            }

            .payment-box img {
                max-height: 20px;
            }
        }
        `}</style>
        </>
    )
}

export default BottomFooter;